import PropertyIcons from './PropertyIcons';
import { getIconClassName } from '@uifabric/styling/lib/index';
import { ControlIcons } from 'owa-control-icons';
import { MailIcons } from 'owa-mail-icons';

const classname = require('classnames');
const styles = require('./propertyIcons.scss');

export default function getPropertyIcon(propertyIcon: PropertyIcons): string {
    switch (propertyIcon) {
        case PropertyIcons.GlobalMentionedMe:
            return classname(styles.accounts, getIconClassName(ControlIcons.Accounts));
        case PropertyIcons.Attachment:
            return getIconClassName(ControlIcons.Attach);
        case PropertyIcons.ImportanceLow:
            return getIconClassName(ControlIcons.Down);
        case PropertyIcons.ImportanceHigh:
            return classname(styles.redDark, getIconClassName(ControlIcons.Important));
        case PropertyIcons.Like:
            return getIconClassName(ControlIcons.Like);
        case PropertyIcons.Snooze:
            return classname(styles.snooze, getIconClassName(ControlIcons.Clock));
        case PropertyIcons.MailListViewReplied:
            return getIconClassName(ControlIcons.Reply);
        case PropertyIcons.MailListViewForwarded:
            return getIconClassName(ControlIcons.Forward);
        case PropertyIcons.MailListViewIRM:
        case PropertyIcons.MailListViewIRMReplied:
        case PropertyIcons.MailListViewIRMForwarded:
            return getIconClassName(ControlIcons.Lock);
        case PropertyIcons.MailListViewVoiceMailItem:
            return getIconClassName(MailIcons.Memo);
        case PropertyIcons.MailListViewVoiceMailReplied:
            return getIconClassName(MailIcons.VoicemailReply);
        case PropertyIcons.MailListViewVoiceMailForwarded:
            return getIconClassName(MailIcons.VoicemailForward);
        case PropertyIcons.MailListViewVoiceMailIRM:
            return getIconClassName(MailIcons.VoicemailIRM);
        case PropertyIcons.MailListViewFaxItem:
            return getIconClassName(MailIcons.Fax);
        case PropertyIcons.MailListViewAppointmentItem:
            return getIconClassName(ControlIcons.Event);
        case PropertyIcons.MailListViewAppointmentAccepted:
            return getIconClassName(ControlIcons.EventAccepted);
        case PropertyIcons.MailListViewAppointmentDeclined:
            return getIconClassName(ControlIcons.EventDeclined);
        case PropertyIcons.MailListViewAppointmentTentative:
            return getIconClassName(ControlIcons.EventTentative);
        case PropertyIcons.MailListViewAppointmentCanceled:
            return getIconClassName(ControlIcons.RemoveEvent);
        case PropertyIcons.MailListViewContactItem:
            return getIconClassName(ControlIcons.ContactCard);
        case PropertyIcons.MailListViewTaskItem:
            return getIconClassName(ControlIcons.CheckboxComposite);
        case PropertyIcons.MailListViewTaskReocurItem:
            return getIconClassName(MailIcons.RecurringTask);
        case PropertyIcons.MailListViewJournalItem:
            return getIconClassName(MailIcons.DietPlanNotebook);
        case PropertyIcons.MailListViewPostItem:
            return getIconClassName(MailIcons.NotePinned);
        case PropertyIcons.MailListViewNoteItem:
            return getIconClassName(MailIcons.QuickNote);
        case PropertyIcons.MailListViewDelivery:
            // Bug 1752 - culture specific
            return getIconClassName(MailIcons.ReceiptForward);
        case PropertyIcons.MailListViewNonDelivery:
            // Bug 1752 - culture specific
            return getIconClassName(MailIcons.ReceiptReply);
        case PropertyIcons.MailListViewApprovalRequest:
            // add sprite response_request.png
            return getIconClassName(MailIcons.ReceiptReply);
        case PropertyIcons.MailListViewResponseApprove:
            // add sprite response_approve.png
            return getIconClassName(MailIcons.ReceiptReply);
        case PropertyIcons.MailListViewResponseReject:
            // add sprite response_reject.png
            return getIconClassName(MailIcons.ReceiptReply);
        case PropertyIcons.MailListViewOutOfOffice:
            // Bug 1752 - culture specific
            return getIconClassName(MailIcons.OutOfOffice);
        case PropertyIcons.MailListViewReadReport:
            return getIconClassName(MailIcons.ReceiptCheck);
        case PropertyIcons.MailListViewReminderMessage:
            return getIconClassName(ControlIcons.Ringer);
        default:
            throw new Error('No CSS class icon for the given property icon');
    }
}
